import React, { Fragment, useState, useEffect } from "react";
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, Table } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faCheck } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";
import Spinner from 'react-bootstrap/Spinner';
import Modal from '@material-ui/core/Modal';
import ListStudyMonitors from './ListStudyMonitors';
import ListStudyMonitorsActions from "./ListStudyMonitorsActions";
import ModalStudyMonitors from './ModalStudyMonitors';

import Tooltip from '@material-ui/core/Tooltip';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';


const StudyMonitorsIndex = ({ location }) => {
    const history = useHistory();
    let feasibility = location.state;

    const [monitors, setMonitors] = React.useState([]);
    const [openModal, setOpenModal] = React.useState(false);

    const listMonitors = async () => {
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}monitorese/listar?id_estudio=${location.state.id_estudio}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(response => response.json()).then(data => {
            console.log("FUNCIONEPUES",data.contenido);
            setMonitors(data.contenido);
        }).catch(err => {
            setMonitors([]);
        });
    }

    useEffect(() => {
        listMonitors();
    }, []);

    const regresar = () => {
        let _url = "/clinical-studio/dashboard";
        history.push({
            pathname: process.env.PUBLIC_URL + _url,
            state: feasibility
        });
    }

    const MemberList = () => {
        return (
            <ListStudyMonitors
                reactTableData={monitors}
                feasibility={feasibility}
                ReactTableActions={ListStudyMonitorsActions}
                refresh={listMonitors}
            />
        );
    }

    return (
        <Container>
            <Row>
                <Col md={12}>
                    <h3 className="page-title center-title">Monitores del Estudio</h3>
                    <h3 className="page-title center-title subhead">{feasibility.nombre_tercero} ({feasibility.acronimo})</h3>
                    <Col md={2}>
                        <div className='top_info_buttons_hc'>
                            <div>
                                <Tooltip
                                    title="Regresar al Dashboard"
                                >
                                    <IconButton
                                        aria-label="upload picture"
                                        component="span"
                                        className='tooltip-top'
                                        onClick={() => {
                                            regresar();
                                        }}
                                    >
                                        <ArrowBackIcon style={{ color: '#153365' }} />
                                    </IconButton>
                                </Tooltip>
                                <span style={{ marginLeft: '0.25em' }}>Regresar al Dashboard</span>
                            </div>
                        </div>
                    </Col>
                </Col>
            </Row>
            <Card>
                <CardBody>
                    <div className="text-center">
                        <Button onClick={() => setOpenModal(true)} className="btn btn-primary btn-sm text-white">
                            Agregar Monitor
                        </Button>
                    </div>
                    <Row>
                        <Container>
                            {
                                monitors.length > 0 ?  <MemberList /> : null
                            }
                        </Container>
                    </Row>
                </CardBody>
            </Card>

            <ModalStudyMonitors
                openModal={openModal}
                closeModal={() => setOpenModal(false)}
                refresh={listMonitors}
                dataMonitor={null}
                idStudy={location.state.id_estudio}
            />
        </Container>
    );
}
export default reduxForm({
    form: 'horizontal_form_criterial_excinc', // a unique identifier for this form
})(StudyMonitorsIndex);